module.exports = __webpack_public_path__ + "components/app-promo/static/icon-intersport-bookmark-5005764438051d49859c4b93831b7ca6.svg";